import AnimatedBackground from "./AnimatedBackground";
import logoBranca from "../assets/logo-branca.png";
import { IconShield, IconHome } from "../icons";

interface BlockedProps {
  /** Mensagem do bloqueio (sem acesso ou falha ao verificar). */
  message: string;
  /** Navega de volta ao Portal levando o usuário. */
  onBackToPortal: () => void;
}

/**
 * Tela cheia exibida enquanto o Portal valida o acesso ao sistema.
 * Não pisca o app: substitui toda a UI por um estado "Verificando acesso...".
 */
export function AccessChecking() {
  return (
    <div className="login">
      <AnimatedBackground />
      <div className="login-form-wrap" style={{ margin: "auto", textAlign: "center" }}>
        <img src={logoBranca} alt="SERCAMP" className="login-mobile-logo" />
        <h1 className="login-title">Verificando acesso...</h1>
        <p className="login-sub">Aguarde enquanto confirmamos suas permissões no Portal.</p>
      </div>
    </div>
  );
}

/**
 * Tela cheia de bloqueio: usuário sem acesso a este sistema (ou falha na
 * verificação). Oferece o caminho de volta ao Portal. O app NÃO é renderizado.
 */
export function AccessBlocked({ message, onBackToPortal }: BlockedProps) {
  return (
    <div className="login">
      <AnimatedBackground />
      <div className="login-form-wrap" style={{ margin: "auto", textAlign: "center" }}>
        <img src={logoBranca} alt="SERCAMP" className="login-mobile-logo" />
        <div
          className="lh-icon"
          style={{ width: 56, height: 56, margin: "0 auto 18px", display: "flex", alignItems: "center", justifyContent: "center" }}
        >
          <IconShield size={28} />
        </div>
        <h1 className="login-title">Acesso negado</h1>
        <p className="login-sub">{message}</p>
        <button
          type="button"
          className="btn-primary login-btn"
          style={{ marginTop: 20 }}
          onClick={onBackToPortal}
        >
          <IconHome size={18} /> Voltar ao Portal
        </button>
      </div>
    </div>
  );
}
